import React, { } from "react";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { useStyles } from "./AssetNonTitledFormStyles";
import { Box, Grid, Typography, IconButton, Tooltip, FormControlLabel, Checkbox } from "@material-ui/core";
import { Save, AccountCircleOutlined } from "@material-ui/icons";
import { actions } from "../AssetReducer";
import useAssetProvider from "../useAssetProvider";

const AssetNonTitledForm = ({ asset, conditions, loadFunction }) => {
	const classes = useStyles();
	const { isReadOnly } = useAssetProvider();
	const tooltipPlacement = "top-end";
	const tooltipManual = "Manual";
	const tooltipSave = "Save";

	return (
		<Box>
			<Grid container direction="row" alignItems="flex-end">
				<Grid item xs={12} align="left">
					<FormControlLabel
						disabled={true}
						className={classes.verticalGap}
						checked={asset?.is_placeholder || false}
						control={<Checkbox color="primary" name="placeholder" />}
						label="Placeholder Asset"
					/>
				</Grid>
				<Grid item xs={5} align="left">
					<TextField
						id="serial-number"
						label="Serial #"
						value={asset?.serial || "No SN"}
						type="text"
						margin="normal"
						disabled
					/>
				</Grid>
				<Grid item xs={5}>
					<TextField
						id="override-serial-number"
						label="Override Serial #"
						style={{ width: "100%" }}
						value={asset?.override_serial || ""}
						margin="normal"
						disabled={isReadOnly || !conditions.edit_asset}
						onChange={(e) => {
							loadFunction({
								functionName: actions.OVERRIDE_SERIAL_NUMBER,
								data: e.target.value,
							});
						}}
					/>
				</Grid>
			</Grid>

			<Grid container direction="row" alignItems="flex-end">
				<Grid item xs={5} align="left">
					<TextField
						id="make"
						label="Make"
						value={asset?.make || "No Make"}
						type="text"
						margin="normal"
						disabled
					/>
				</Grid>
				<Grid item xs={5}>
					{!isReadOnly &&
						conditions.edit_asset &&
						!conditions.isManualMake &&
						conditions.makeChoices.length > 0 && (
							<FormControl className={classes.formControl} style={{ width: "100%" }}>
								<InputLabel id="override-make-label">Override Make</InputLabel>

								<Select
									style={{ width: "100%" }}
									id="override-make-select"
									labelId="override-make-label"
									value={asset?.override_make || ""}
									onChange={(e) => {
										loadFunction({
											functionName: actions.LOAD_EW_MODEL_CHOICES,
											data: e.target.value,
										});
									}}>
									{conditions.makeChoices &&
										conditions.makeChoices.map((make) => (
											<MenuItem key={make.manufacturerId} value={make.manufacturerName}>
												{make.manufacturerName}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						)}

					{(conditions.isManualMake ||
						conditions.makeChoices.length === 0 ||
						!conditions.edit_asset) && (
							<TextField
								style={{ width: "100%" }}
								id="override-make"
								label="Override Make"
								value={asset?.override_make || ""}
								margin="normal"
								disabled={
									isReadOnly || !conditions.edit_asset
								}
								onChange={(e) => {
									loadFunction({
										functionName: actions.OVERRIDE_MAKE,
										data: e.target.value,
									});
								}}
							/>
						)}
				</Grid>
				{!isReadOnly && conditions.edit_asset && !conditions.searchVIN && (
					<Grid item xs={2}>

						{conditions.makeChoices.length > 0 && !conditions.isManualMake && (
							<Tooltip title={tooltipManual} placement={tooltipPlacement}>
								<IconButton
									onClick={() => {
										//setIsManualMake(true);
										loadFunction({
											functionName: actions.IS_MANUAL_MAKE,
											data: true,
										});
									}}>
									<AccountCircleOutlined />
								</IconButton>
							</Tooltip>
						)}

						{conditions.isManualMake && asset.override_make && (
							<Tooltip title={tooltipSave} placement={tooltipPlacement}>
								<IconButton
									color="primary"
									onClick={() => {
										//setIsManualMake(true);
										loadFunction({
											functionName: actions.VERIFY_EW_MAKE,
											data: null,
										});
									}}>
									<Save />
								</IconButton>
							</Tooltip>
						)}
					</Grid>
				)}
			</Grid>

			<Grid container direction="row" alignItems="flex-end">
				<Grid item xs={5} align="left">
					<TextField
						id="model"
						label="Model"
						value={asset?.model || "No Model"}
						type="text"
						margin="normal"
						disabled
					/>
				</Grid>
				<Grid item xs={5}>
					{!isReadOnly &&
						conditions.edit_asset &&
						!conditions.isManualModel &&
						conditions.modelChoices.length > 0 && (
							<FormControl className={classes.formControl} style={{ width: "100%" }}>
								<InputLabel id="override-model-label">Override Model</InputLabel>

								<Select
									style={{ width: "100%" }}
									id="override-model-select"
									labelId="override-model-label"
									value={asset.override_model || ""}
									onChange={(e) => {
										loadFunction({
											functionName: actions.LOAD_EW_CONFIG_CHOICES,
											data: e.target.value,
										});
									}}>
									{conditions.modelChoices &&
										conditions.modelChoices.map((model) => (
											<MenuItem key={model.modelId} value={model}>
												{model.modelName}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						)}

					{(conditions.isManualModel ||
						conditions.modelChoices.length === 0 ||
						!conditions.edit_asset) && (
							<TextField
								style={{ width: "100%" }}
								id="override-model"
								label="Override Model"
								value={asset?.override_model || ""}
								margin="normal"
								disabled={
									isReadOnly || !conditions.edit_asset
								}
								onChange={(e) =>
									loadFunction({
										functionName: actions.OVERRIDE_MODEL,
										data: e.target.value,
									})
								}
							/>
						)}
				</Grid>
				{!isReadOnly && conditions.edit_asset && !conditions.searchVIN && (
					<Grid item xs={2}>

						{conditions.modelChoices.length > 0 && !conditions.isManualModel && (
							<Tooltip title={tooltipManual} placement={tooltipPlacement}>
								<IconButton
									color="primary"
									onClick={() => {
										//setIsManualMake(true);
										loadFunction({
											functionName: actions.IS_MANUAL_MODEL,
											data: true,
										});
									}}>
									<AccountCircleOutlined />
								</IconButton>
							</Tooltip>
						)}

						{conditions.isManualModel && asset.override_model && (
							<Tooltip title={tooltipSave} placement={tooltipPlacement}>
								<IconButton
									color="primary"
									onClick={() => {
										//setIsManualMake(true);
										loadFunction({
											functionName: actions.VERIFY_EW_MODEL,
											data: null,
										});
									}}>
									<Save />
								</IconButton>
							</Tooltip>
						)}
					</Grid>
				)}
			</Grid>

			<Grid container direction="row" alignItems="flex-end">
				<Grid item xs={5} align="left">
					<TextField
						id="config"
						label="Description"
						value={asset?.description || "No Description"}
						type="text"
						margin="normal"
						disabled
					/>
				</Grid>
				<Grid item xs={5}>
					{!isReadOnly &&
						conditions.edit_asset &&
						!conditions.isManualConfig &&
						conditions.configChoices.length > 0 && (
							<FormControl className={classes.formControl} style={{ width: "100%" }}>
								<InputLabel id="override-config-label">Override Description</InputLabel>

								<Select
									style={{ width: "100%" }}
									id="override-config-select"
									labelId="override-config-label"
									value={asset?.override_description || ""}
									onChange={(e) => {
										loadFunction({
											functionName: actions.OVERRIDE_EW_DESCRIPTION,
											data: e.target.value,
										});
										// selectEWConfig();alue.categoryName + ' - ' + value.subtypeName
									}}>
									{conditions.configChoices &&
										conditions.configChoices.map((config) => (
											<MenuItem key={config.modelId} value={config}>
												{config.categoryName} - {config.subtypeName}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						)}

					{(conditions.isManualConfig ||
						conditions.configChoices.length === 0 ||
						!conditions.edit_asset) && (
							<TextField
								style={{ width: "100%" }}
								id="override-config"
								label="Type Description"
								value={asset?.override_description || ""}
								margin="normal"
								disabled={
									isReadOnly || !conditions.edit_asset
								}
								onChange={(e) =>
									loadFunction({
										functionName: actions.SET_OVERRIDE_EW_DESCRIPTION,
										data: e.target.value,
									})
								}
							/>
						)}
				</Grid>
				{!isReadOnly && conditions.edit_asset && !conditions.searchVIN && (
					<Grid item xs={2}>


						{conditions.configChoices.length > 0 && !conditions.isManualConfig && (
							<Tooltip title={tooltipManual} placement={tooltipPlacement}>
								<IconButton
									color="primary"
									onClick={() => {
										//setIsManualMake(true);
										loadFunction({
											functionName: actions.IS_MANUAL_CONFIG,
											data: true,
										});
									}}>
									<AccountCircleOutlined />
								</IconButton>
							</Tooltip>
						)}

						{conditions.isManualConfig && asset.override_description && (
							<Tooltip title={tooltipSave} placement={tooltipPlacement}>
								<IconButton
									color="primary"
									onClick={() => {
										//setIsManualMake(true);
										loadFunction({
											functionName: actions.LOAD_EW_YEAR_CHOICES,
										});
									}}>
									<Save />
								</IconButton>
							</Tooltip>
						)}
					</Grid>
				)}
			</Grid>

			<Grid container direction="row" alignItems="flex-end">
				<Grid item xs={5} align="left">
					<TextField
						id="year"
						label="Year"
						value={asset?.year || "No Year"}
						type="text"
						margin="normal"
						disabled
					/>
				</Grid>
				<Grid item xs={5}>
					{!isReadOnly &&
						conditions.edit_asset &&
						!conditions.searchVIN &&
						conditions.yearChoices.length > 0 && (
							<FormControl className={classes.formControl} style={{ width: "100%" }}>
								<InputLabel id="override-year-label">Override Year</InputLabel>

								<Select
									style={{ width: "100%" }}
									id="override-year-select"
									labelId="override-year-label"
									value={asset?.override_year || ""}
									onChange={(e) => {
										loadFunction({
											functionName: actions.SELECT_EW_YEAR,
											data: e.target.value,
										});
									}}>
									{conditions.yearChoices &&
										conditions.yearChoices.map((year) => (
											<MenuItem key={year} value={year}>
												{year}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						)}

					{(conditions.yearChoices.length === 0 || !conditions.edit_asset) && (
						<TextField
							style={{ width: "100%" }}
							id="override-year"
							label="Override Year"
							value={asset?.override_year || ""}
							margin="normal"
							disabled={
								isReadOnly || !conditions.edit_asset
							}
							onChange={(e) =>
								loadFunction({
									functionName: actions.OVERRIDE_YEAR,
									data: e.target.value,
								})
							}
						/>
					)}
				</Grid>
				{!isReadOnly &&
					conditions.edit_asset &&
					!conditions.searchVIN &&
					conditions.isYear && (
						<Grid item xs={2}>


							{!conditions.isManualYear && conditions.yearChoices.length > 0 && (
								<Tooltip title={tooltipManual} placement={tooltipPlacement}>
									<IconButton
										color="primary"
										onClick={() => {
											//setIsManualMake(true);
											loadFunction({
												functionName: actions.IS_MANUAL_YEAR,
												data: true,
											});
										}}>
										<AccountCircleOutlined />
									</IconButton>
								</Tooltip>
							)}
							{conditions.isManualYear && (
								<Tooltip title={tooltipSave} placement={tooltipPlacement}>
									<IconButton
										color="primary"
										onClick={() => {
											//setIsManualMake(true);
											loadFunction({
												functionName: actions.SAVE_EW_YEAR,
												data: true,
											});
										}}>
										<Save />
									</IconButton>
								</Tooltip>
							)}
						</Grid>
					)}
			</Grid>

			<Grid container direction="row" alignItems="flex-end">
				<Grid item xs={5} align="left">
					<TextField
						id="condition"
						label="Condition"
						value={asset?.condition || "No Condition"}
						type="text"
						margin="normal"
						disabled
					/>
				</Grid>
				<Grid item xs={5}>
					{!isReadOnly && conditions.edit_asset ? (
						<FormControl className={classes.formControl} style={{ width: "100%" }}>
							{/* <InputLabel id="override-condition-label">Override Condition</InputLabel> */}
							<Typography
								style={{
									position: "relative",
									top: "6px",
									fontSize: "14px",
									color: "#8B9FB3",
									textAlign: "left",
								}}>
								Override Condition
							</Typography>
							<Select
								style={{ width: "100%" }}
								id="override-condition-select"
								labelId="override-condition-label"
								value={asset?.override_condition || ""}
								onChange={(e) =>
									loadFunction({
										functionName: actions.SET_OVERRIDE_CONDITION,
										data: e.target.value,
									})
								}>
								{" "}
								<MenuItem value="New">New</MenuItem>
								<MenuItem value="Used">Used</MenuItem>
							</Select>
						</FormControl>
					) : (
						<TextField
							style={{ width: "100%" }}
							id="override-condition"
							label="Override Condition"
							value={asset?.override_condition || ""}
							margin="normal"
							disabled
						/>
					)}
				</Grid>
				<Grid item xs={2} />
			</Grid>

			<Grid container direction="row" alignItems="flex-end">
				<Grid item xs={5} align="left">
					<TextField
						id="usage-hours"
						label="Usage Hours"
						value={asset?.hours || "No Usage Hours"}
						type="text"
						margin="normal"
						disabled
					/>
				</Grid>
				<Grid item xs={5}>
					<TextField
						style={{ width: "100%" }}
						id="override-usage-hours"
						label="Override Hours"
						value={asset?.override_hours}
						type="text"
						margin="normal"
						disabled={isReadOnly || !conditions.edit_asset}
						inputProps={{
							maxLength: 7,
						}}
						onChange={(e) =>
							loadFunction({
								functionName: actions.SET_OVERRIDE_HOURS,
								data: e.target.value.replace(/[\D,-]/g, ''),
							})
						}
					/>
				</Grid>
				<Grid item xs={2} />
			</Grid>
		</Box>
	);
};
export default AssetNonTitledForm;
